var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"wrapper-in"},[_vm._m(0),_c('section',{staticClass:"daftarkan-list"},[_c('Tabs')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"daftarkan-perolehan"},[_c('div')])
}]

export { render, staticRenderFns }